import React, { useEffect, useState } from "react";
import avatar from "../../../../images/no-image.png";
import postImage from "../../../../images/t-10.jpg";
import axios from "axios";
import CardBackground from "../../../../components/MainTemplate/CardBackground";
import dayjs from "dayjs";
import moment from "moment";

import { useAtom } from "jotai";
import { gbState } from "../../../../components/shared/GlobalState";

const PostComponent = ({ refreshPosts }) => {
  const [{ errorLogApi, placeHolderText, user }] = useAtom(gbState);
  const [data, setData] = useState([]);
  const [selectedImageModal, setSelectedImageModal] = useState(null);

  let userImage = localStorage.getItem("user_image");

  const getDataFromServer = () => {
    let userToken = localStorage.getItem("token");

    let urlLink = `${process.env.REACT_APP_API_URL}/post/${user.church_id}`;

    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };
    axios(config)
      .then(function (response) {
        const oldData = response.data.posts;
        const updatedData = oldData.map((data) => ({
          ...data,
          id: data._id,
          title: data.title,
          description: data.description,
          file_type: data.file_type,
          upload_file: data.upload_file,
          likes: 0,
        }));
        setData(updatedData);
        // Fetch likes for each post
        updatedData.forEach((post) => {
          getNumberOfLikes(post._id);
        });
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  };

  useEffect(() => {
    getDataFromServer();
  }, [refreshPosts]);

  const getNumberOfLikes = (id) => {
    let userToken = localStorage.getItem("token");

    let urlLink = `${process.env.REACT_APP_API_URL}/like/${id}`;

    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios(config)
      .then(function (response) {
        const likes = response?.data?.likes;
        setData((prevData) =>
          prevData.map((post) =>
            post.id === id ? { ...post, likes: likes } : post
          )
        );
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  };

  const addLikeToPost = (id) => {
    let userToken = localStorage.getItem("token");

    let urlLink = `${process.env.REACT_APP_API_URL}/like/add/${id}`;

    const config = {
      method: "POST",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios(config)
      .then(function (response) {
        getNumberOfLikes(id);
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  };

  return (
    <div className="mt-4 space-y-4">
      {/* Image Modal */}
      {selectedImageModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70"
          onClick={() => setSelectedImageModal(null)}
        >
          <div className="relative max-w-4xl max-h-[90vh] w-full mx-4">
            <button
              className="absolute p-2 text-white transition-colors rounded-full top-4 right-4 bg-black/50 hover:bg-black/70"
              onClick={() => setSelectedImageModal(null)}
            >
              <i className="text-xl mdi mdi-close" />
            </button>
            <img
              src={selectedImageModal}
              alt="Full size"
              className="object-contain w-full h-full"
              crossOrigin="anonymous"
            />
          </div>
        </div>
      )}
      {data && data.length > 0 ? (
        data.map((item, index) => (
          <CardBackground key={index}>
            <div className="w-full p-3 space-y-4">
              {/* Header Section */}
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="relative">
                    {item?.created_by?.image !== "undefined" || null ? (
                      <img
                        crossOrigin="anonymous"
                        src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/employee/${item?.created_by?.image}`}
                        className="object-cover w-12 h-12 border-2 border-gray-200 rounded-full"
                        alt="Profile"
                      />
                    ) : (
                      <img
                        src={avatar}
                        className="object-cover w-12 h-12 border-2 border-gray-200 rounded-full"
                        alt="Default Profile"
                      />
                    )}
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-800">
                      {item?.created_by?.first_name +
                        " " +
                        item?.created_by?.last_name}
                    </h3>
                    <p className="text-sm text-gray-500">
                      {moment(item.createdAt).fromNow()}
                    </p>
                  </div>
                </div>
                <button className="p-2 transition-colors rounded-full hover:bg-gray-100">
                  <i className="text-xl text-gray-600 mdi mdi-dots-horizontal" />
                </button>
              </div>

              {/* Content Section */}
              <div className="space-y-3">
                <h2 className="text-xl font-semibold text-gray-800">
                  {item.title}
                </h2>
                <p className="leading-relaxed text-gray-600">
                  {item.description}
                </p>

                {/* Date & Time */}
                <div className="flex items-center space-x-4 text-sm text-gray-500">
                  <div className="flex items-center">
                    <i className="mr-2 text-gray-400 mdi mdi-calendar-blank" />
                    {dayjs(item.createdAt).format("MMMM DD, YYYY")}
                  </div>
                  <div className="flex items-center">
                    <i className="mr-2 text-gray-400 mdi mdi-clock-outline" />
                    {dayjs(item.createdAt).format("hh:mm A")}
                  </div>
                </div>
              </div>

              {/* Media Section */}
              {item?.upload_file && (
                <div className="overflow-hidden bg-gray-100 rounded-lg">
                  {item?.file_type === "image" ? (
                    <div
                      className="relative cursor-pointer group"
                      onClick={() =>
                        setSelectedImageModal(
                          `${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/post/${item?.upload_file}`
                        )
                      }
                    >
                      <img
                        src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/post/${item?.upload_file}`}
                        className="object-cover w-full h-64"
                        alt=""
                        crossOrigin="anonymous"
                      />
                      <div className="absolute inset-0 flex items-center justify-center transition-colors bg-black/0 group-hover:bg-black/20">
                        <i className="text-3xl text-white transition-opacity opacity-0 mdi mdi-magnify group-hover:opacity-100" />
                      </div>
                    </div>
                  ) : (
                    <div className="aspect-video max-h-[360px]">
                      <video
                        controls
                        className="object-contain w-full h-full bg-black"
                        crossOrigin="anonymous"
                      >
                        <source
                          src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/post/${item?.upload_file}`}
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  )}
                </div>
              )}

              {/* Interaction Section */}
              <div className="flex items-center pt-3 border-t border-gray-100">
                <button
                  onClick={() => addLikeToPost(item.id)}
                  className="flex items-center space-x-2 text-gray-600 transition-colors hover:text-blue-600"
                >
                  <i className="text-xl mdi mdi-thumb-up-outline" />
                  <span>{item.likes} Likes</span>
                </button>
              </div>
            </div>
          </CardBackground>
        ))
      ) : (
        <CardBackground>
          <div className="py-8 text-center">
            <i className="mb-2 text-4xl text-gray-400 mdi mdi-post-outline" />
            <p className="font-medium text-gray-600">No posts available</p>
          </div>
        </CardBackground>
      )}
    </div>
  );
};

export default PostComponent;
